module.exports = __webpack_public_path__ + "img/banner.8ef9b6eb.png";